//angular imports
import { 
  ChangeDetectionStrategy, 
  Component,  
  Signal, 
  computed, 
} from '@angular/core';

//local imports
import { Messenger } from '@app/shared';
import { UserLoggedInMessage } from '@app/core';

export class UserHeader {
  username: Signal<string>;  
}

@Component({
    selector: 'current-user-header',
    templateUrl: './current-user-header.component.html',
    styleUrl: './current-user-header.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CurrentUserHeaderComponent  {

  private userLoggedIn: Signal<UserLoggedInMessage>;

  public username = computed(() =>
  {
     let loggedInMsg = this.userLoggedIn();
     return loggedInMsg?.User?.name;
  });

  constructor(
    private messenger: Messenger) {

    this.userLoggedIn = this.messenger.getSignal(UserLoggedInMessage);
  }

}


